import StringMask from 'string-mask';
import { MASK, MASK_WITH_COUNTRY_CODE, NATIONAL_NUMBER_DIGITS, ONLY_DIGITS_REGEX } from '../utilities/constants';
import unmaskValue from '../components/utilities/unmaskValue';

/**
 * Strips the display mask down to bare digits, for values leaving the app in a request.
 * Keeps a country code intact, which a fixed-width re-mask would drop.
 * @param {string} str Masked phone number
 * @returns {string} Digits only
 */
export const unmaskPhone = str => unmaskValue(str || '', ONLY_DIGITS_REGEX);

/**
 * Formats a stored number for display. Widens to the country-code pattern past ten
 * digits, matching PHONE_MASK_FOR_MASKED_FIELD, so an eleven-digit record is not
 * displayed as a different ten-digit number.
 * @param {string} str Phone number, masked or bare
 * @returns {string} Masked phone number
 */
export const maskPhone = str => {
  const digits = unmaskPhone(str);
  const pattern = digits.length > NATIONAL_NUMBER_DIGITS ? MASK_WITH_COUNTRY_CODE : MASK;

  return StringMask.process(digits, pattern).result;
};
